<div class="page-container product-shelf-container container">
  @if (programChooser) {
    <div>
      <div>
        <h1 class="header mb-2">Product Shelf</h1>
        <h4>Filter on Program Name</h4>
      </div>
      <mat-form-field class="w-50">
        <mat-select [(ngModel)]="programName">
          @for (option of programOptions; track option) {
            <mat-option [value]="option">
              {{ option }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="col-12 buttons">
        <button
          mat-raised-button
          (click)="sendProgramOut()"
          class="ms-2"
          color="accent"
          [disabled]="!programName"
        >
          <mat-icon aria-label="Search Using Program Name">search</mat-icon>
          Search Using Program Name
        </button>
      </div>
    </div>
    <h2 class="program-filter-divider">OR</h2>
    <div>
      <div>
        <h4>Apply a Saved Filter</h4>
      </div>
      <app-manage-filters
        [grid]="gridConfig.gridName"
        [searchOnly]="true"
        (sendTemplateOut)="selectTemplate($event)"
      ></app-manage-filters>

      <div class="col-12 buttons">
        <button
          mat-raised-button
          (click)="sendTemplateOut()"
          class="ms-2"
          color="accent"
          [disabled]="!templateDataToUse"
        >
          <mat-icon aria-label="Search Using Saved Filter Template">
            search
          </mat-icon>
          Search Using Saved Filter Template
        </button>
      </div>
    </div>
    <ngx-loading [show]="loading"></ngx-loading>
  } @else {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    >
    </app-rb-grid>
  }
</div>
<ngx-loading [show]="loading"></ngx-loading>
